import UpcomingAppointmentsCard from './UpcomingAppointmentsCard';
import PendingBookingsCard from './PendingBookingsCard';
import UnreadMessagesCard from './UnreadMessagesCard';
import CRMRemindersCard from './CRMRemindersCard';
import StaffScheduleCard from './StaffScheduleCard';
import BookingStatisticsCard from './BookingStatisticsCard';
import RecentFormSubmissionsCard from './RecentFormSubmissionsCard';

export const CARD_REGISTRY = {
  'upcoming-appointments': {
    id: 'upcoming-appointments',
    title: 'Upcoming Appointments',
    component: UpcomingAppointmentsCard,
    defaultEnabled: true,
    category: 'Bookings',
    permissions: ['view_bookings'],
  },
  'pending-bookings': {
    id: 'pending-bookings',
    title: 'Bookings Needing Approval',
    component: PendingBookingsCard,
    defaultEnabled: true,
    category: 'Bookings',
    permissions: ['view_bookings'],
  },
  'unread-messages': {
    id: 'unread-messages',
    title: 'Unread Messages',
    component: UnreadMessagesCard,
    defaultEnabled: true,
    category: 'Messages',
    permissions: ['view_messages'],
  },
  'crm-reminders': {
    id: 'crm-reminders',
    title: 'Reminders',
    component: CRMRemindersCard,
    defaultEnabled: true,
    category: 'My couples',
    permissions: ['view_bookings'],
  },
  'staff-schedule': {
    id: 'staff-schedule',
    title: 'Staff Schedule',
    component: StaffScheduleCard,
    defaultEnabled: true,
    category: 'Staff',
    permissions: ['manage_staff'],
  },
  'booking-statistics': {
    id: 'booking-statistics',
    title: 'Booking Statistics',
    component: BookingStatisticsCard,
    defaultEnabled: false,
    category: 'Analytics',
    permissions: ['view_bookings'],
  },
  'recent-form-submissions': {
    id: 'recent-form-submissions',
    title: 'Recent form responses',
    component: RecentFormSubmissionsCard,
    defaultEnabled: false,
    category: 'Forms',
    permissions: ['view_profile'],
  },
};

export const DEFAULT_ENABLED_CARDS = [
  'upcoming-appointments',
  'pending-bookings',
  'unread-messages',
  'crm-reminders',
  'staff-schedule',
];

export const getCardById = (id) => CARD_REGISTRY[id];

export const getAllCards = () => Object.values(CARD_REGISTRY);

export const getEnabledCards = (preferences = {}) => {
  const enabled = Object.keys(CARD_REGISTRY).filter(id => {
    if (preferences[id] !== undefined) {
      return preferences[id];
    }
    return DEFAULT_ENABLED_CARDS.includes(id);
  });
  return enabled.map(id => CARD_REGISTRY[id]);
};
